<template>
  <div
    class="toggle-button outline-button"
    :class="{ on: value }"
    @click="toggle()"
  >
    <div class="toggle">
      <div class="nipple"></div>
    </div>
    {{ label }}
  </div>
</template>

<script>
export default {
  name: 'ToggleButton',
  props: {
    label: String,
    onChange: Function,
    value: Boolean,
  },
  methods: {
    toggle() {
      if (!this.onChange) return;
      this.onChange(!this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.toggle-button {
  margin-left: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;

  &.on {
    .nipple {
      left: 21px;
    }

    .toggle {
      background: $blue;
      border-color: $blue;
    }
  }

  .toggle {
    width: 40px;
    height: 16px;
    border-radius: 8px;
    background: #dce0e9;
    border: 1px solid rgba(98, 109, 121, 0.1);
    transition: border 0.4s, background 0.4s;
    position: relative;
    display: inline-block;
    margin-right: 8px;
    top: 0px;
  }

  .nipple {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #d8dae1;
    background: white;
    position: absolute;
    top: -3px;
    left: -1px;
    transition: left 0.4s;
  }
}
</style>
